import * as React from 'react';
import { HeaderThElement } from './HeaderThElement';
import { getFilterColumnId } from '../navigation/utils';
import { useLocalization } from '@progress/kendo-react-intl';
import { filterAriaLabel, messages } from '../messages';
/**
 * @hidden
 */
export var FILTER_ROW_CLASS = 'k-filter-row';
var headerCellClassName = function (sort, field, locked) {
    var result = "" + (locked ? 'k-grid-header-sticky' : '');
    if (sort.some(function (descriptor) { return descriptor.field === field; })) {
        result += ' k-sorted';
    }
    return result;
};
/**
 * @hidden
 */
export var FilterRow = function (props) {
    var columns = props.columns, filter = props.filter, filterChange = props.filterChange, _a = props.sort, sort = _a === void 0 ? [] : _a, ariaRowIndex = props.ariaRowIndex;
    var intl = useLocalization();
    return (React.createElement("tr", { className: FILTER_ROW_CLASS, "aria-rowindex": ariaRowIndex }, columns.map(function (column, index) {
        var style = (column.locked !== undefined) ? {
            left: column.left,
            right: column.right,
            borderRightWidth: column.rightBorder ? '1px' : ''
        } : {};
        return (React.createElement(HeaderThElement, { columnId: getFilterColumnId(column.id), navigatable: column.navigatable, style: style, key: index, ariaColumnIndex: column.ariaColumnIndex, ariaLabel: column.filter ? intl.toLanguageString(filterAriaLabel, messages[filterAriaLabel]) : undefined, className: headerCellClassName(sort, column.field, column.locked) }, column.filter && (React.createElement(column.filter, { field: column.field, filter: filter, onFilterChange: filterChange }))));
    })));
};
//# sourceMappingURL=FilterRow.js.map